export type PriceTierOrderRuleItemType =
  | "can"
  | "bottle"
  | "keg"
  | "cask"
  | "draught"
  | "any"
  | "bagInBox";

export type PriceTierOrderRuleFormValues = {
  itemType: PriceTierOrderRuleItemType;
  quantity: number;
  volume?: number | null;
  unit?: "L" | null;
};

export type MoqItemTypeOption = {
  value: string;
  label: string;
};

export const MOQ_ITEM_TYPE_OPTIONS: MoqItemTypeOption[] = [
  {
    label: "Cases of cans",
    value: "can",
  },
  {
    label: "Cases of bottles",
    value: "bottle",
  },
  {
    label: "Kegs",
    value: "keg",
  },
  {
    label: "Casks",
    value: "cask",
  },
  {
    label: "Draught items (keg or cask)",
    value: "draught",
  },
  {
    label: "Bag In Box",
    value: "bagInBox",
  },
  {
    label: "Any",
    value: "any",
  },
];
